import { DataProviderType } from '@augloop-types/honeybee';
import { SonoraDataProviderConfig, SonoraEntityType } from 'owa-editor-sonora-types';

export default function getSonoraDataProviders(dataProviderConfig: SonoraDataProviderConfig) {
    const { dataProviderEnabledStatus } = dataProviderConfig;

    // Data provider list to fetch from UserDataService.
    const userDataServiceDataProviders: DataProviderType[] = [];

    // Get the provider list purely based on data provider config.
    if (dataProviderEnabledStatus[SonoraEntityType.StickyNotes]) {
        userDataServiceDataProviders.push(DataProviderType.SubstrateSearchQueryStickynotes);
    }
    if (dataProviderEnabledStatus[SonoraEntityType.File]) {
        userDataServiceDataProviders.push(DataProviderType.SubstrateSearchSuggestions);
    }
    if (dataProviderEnabledStatus[SonoraEntityType.MeetingTimes]) {
        userDataServiceDataProviders.push(DataProviderType.MeetingTimes);
    }
    if (
        dataProviderEnabledStatus[SonoraEntityType.VivaTopicFile] ||
        dataProviderEnabledStatus[SonoraEntityType.VivaTopicPerson] ||
        dataProviderEnabledStatus[SonoraEntityType.VivaTopicEntity]
    ) {
        userDataServiceDataProviders.push(DataProviderType.VivaTopics);
    }
    if (dataProviderEnabledStatus[SonoraEntityType.Contact]) {
        userDataServiceDataProviders.push(DataProviderType.ChainedContacts);
    }

    return userDataServiceDataProviders;
}
